"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselItem = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const lodash_1 = require("lodash");
const CarouselItem_1 = __importDefault(require("../CarouselItem"));
exports.CarouselItem = CarouselItem_1.default;
/**
 * Carousel
 * @block
 * @requiresHooks
 */
const Carousel = ({ children, className, classNames = [], showArrows = true, showBullets = true, perView = 1, startAt = 0, backgroundColor = 'transparent', backgroundImage, textColor, options = {}, onMount, id = 'carousel-component', }) => {
    const [numSlides, setNumSlides] = (0, react_1.useState)(0);
    const ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        // @ts-ignore - can't find types even though types are installed
        Promise.resolve().then(() => __importStar(require('@glidejs/glide/dist/glide.esm'))).then(({ default: Glide }) => {
            if (!ref.current) {
                return;
            }
            const carousel = ref.current;
            const totalSlides = carousel.querySelectorAll('.glide__slide').length;
            setNumSlides(totalSlides);
            if (carousel.dataset.initialized === 'true' || numSlides < 1) {
                // either already initialized or not ready with numSlides yet.
                return;
            }
            const glide = new Glide(`#${id}`, Object.assign({ type: 'carousel', startAt,
                perView }, options));
            glide.on('move', () => {
                carousel.classList.add('moving');
            });
            glide.on('move.after', () => {
                carousel.classList.remove('moving');
            });
            const mountCarousel = () => {
                if (carousel.dataset.initialized === 'true' ||
                    totalSlides < 1) {
                    return;
                }
                carousel.dataset.initialized = 'true';
                glide.mount();
                onMount && onMount(glide, ref.current);
            };
            // Initialize inside tabs
            const tabPane = carousel.closest('.tab-pane');
            if (tabPane !== null && !tabPane.classList.contains('active')) {
                const button = document.querySelector(`#${tabPane.id}-tab`);
                button &&
                    button.addEventListener('shown.bs.tab', mountCarousel);
            }
            else {
                mountCarousel();
            }
        });
    }, [startAt, perView, id, numSlides]);
    return (react_1.default.createElement("div", { className: className ||
            (0, classnames_1.default)('glide', 'carousel', `carousel--items-${numSlides}`, `bg-${backgroundColor}`, !textColor && backgroundColor === 'dark' && `text-light`, textColor && `text-${textColor}`, numSlides > 0 && 'pb-4', backgroundImage && 'has-background', ...classNames), style: backgroundImage && {
            backgroundImage: `url('${backgroundImage.src}')`,
        }, ref: ref, id: id },
        react_1.default.createElement("div", { className: "glide__track", "data-glide-el": "track" },
            react_1.default.createElement("ul", { className: "glide__slides" }, children)),
        showArrows && children && (react_1.default.createElement("div", { className: "glide__arrows", "data-glide-el": "controls" },
            react_1.default.createElement("button", { className: "btn btn-default glide__arrow glide__arrow--left", "data-glide-dir": "<", "aria-label": "Previous" },
                react_1.default.createElement("i", { className: "icon icon-chevron-left" })),
            react_1.default.createElement("button", { className: "btn btn-default glide__arrow glide__arrow--right", "data-glide-dir": ">", "aria-label": "Next" },
                react_1.default.createElement("i", { className: "icon icon-chevron-right" })))),
        showBullets && (react_1.default.createElement("div", { className: "glide__bullets", "data-glide-el": "controls[nav]" }, numSlides > 0 &&
            (0, lodash_1.range)(0, numSlides).map((_, index) => (react_1.default.createElement("button", { key: index, className: "glide__bullet", "data-glide-dir": `=${index}`, "aria-label": `Go to slide ${index + 1}` })))))));
};
exports.default = Carousel;
